import { Flame } from "lucide-react";

const ITEMS = [
  "Chimney Sweeping",
  "Chimney Repair",
  "Crowns",
  "Caps",
  "Flashing",
  "Tuckpointing",
];

function MarqueeRow() {
  return (
    <div className="flex items-center gap-12 pr-12">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-12">
          <span className="font-heading text-sm uppercase tracking-[0.35em] font-semibold text-white/50">
            {item}
          </span>
          <Flame className="w-4 h-4 text-primary shrink-0" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden bg-foreground py-6 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max">
        <MarqueeRow />
        <MarqueeRow />
      </div>
    </div>
  );
}
